const SHOP_DOMAIN = "ofrex.ch";
const SHOP_ID = "90585891189";
const STOREFRONT = "d4d1946bbd72dc2a3b438a38849a9ad5";
const CLIENT_ID = "350aca84-52a5-41c4-9f71-46d6393d9bb8";
const REDIRECT = "https://ofrex.ch";
const CONTACT_EMAIL = "info@ofrex.ch";
const WASSER_TAG = "supplier:Waser";
const SPECIFIC_SUPPLIER_TAGS = ["supplier:LaborTeam"];

const VERSION_GRAPH = "2025-07";

const API_BACKEND_LITESTAR = `https://ofrex-litestar-3esyjxcrka-oa.a.run.app`;
const POSTHOG_KEY = "phc_kpTQea2gCRW65WHnTs9fD2tHhHQbfNJ3rMKTHK5iNFEP";
const POSTHOG_HOST = "https://eu.i.posthog.com";
const POSTHOG_ENV = "production";

const PUNCHOUT_API_KEY = "jWtPD55RM26iDW77PO3naOgh7uGVgUtIoCIsvUTusiIyZn";
const PUNCHOUT_ACCOUNTS = ["repower@ofrex.ch"];
const SHOW_BASE_PRICE_EMAILS = ["cca@ofrex.ch"];
const SHOW_BASE_PRICE_EXTERNAL_IDS = ["99801929", "99801947", "310094"];
const SHOW_NO_PUBLIC_PRODUCTS = ["40109310325"];

const SECRET_EMAILS = ["bbjelica+secret@propeler.io", "@historical.ofrex.ch"];

const TITLE_ABOVE_SUPPLIER_LIST = [
  "Waser",
  "Ofrex",
  "Brieger",
  "Antalis",
  "Fischerpapier",
  "Dallmayr",
  "Papyrus",
  "Ledergerber",
  "Interprinting",
  "Dynakom",
  "Kolok",
  "GebrBuhlerZurich",
  "DIMAP-BMI",
  "CWS",
];

const COST_CENTER_SUPPLIER_LIST = [
  "Waser",
  "Ofrex",
  "Brieger",
  "Antalis",
  "Fischerpapier",
  "Dallmayr",
  "Papyrus",
  "Ledergerber",
  "Interprinting",
  "Dynakom",
  "Kolok",
  "GebrBuhlerZurich",
  "StempelGlatz",
  "DIMAP-BMI",
  "CWS",
];

const NOTE_SUPPLIER_LIST = [
  "Waser",
  "Ofrex",
  "Brieger",
  "Fischerpapier",
  "Dallmayr",
  "Papyrus",
  "Ledergerber",
  "Interprinting",
  "Dynakom",
  "Kolok",
  "GebrBuhlerZurich",
  "StempelGlatz",
  "DIMAP-BMI",
  "CWS",
];

const MENU_DATA_BLACKLIST = ["software_lizenzen"];

const INFO_EMAIL_SHOP = "info@ofrex.ch";
const CONTACT_EMAIL_SHOP = "RMA@ofrex.ch";
const ALGOLIA_APP_ID = "R1XKVSC99W";
const ALGOLIA_API_KEY = "8d5895dfddfdc3ff04f7bb0e04b76fde";
const ALGOLIA_AUTOCOMPLETE_API_KEY = "acf1115ec75cfb768df51439790b9b10";
const ALGOLIA_CHAT_API_KEY = ALGOLIA_API_KEY;
const ALGOLIA_INDEX_NAME = "prod_bq_products";
const ALGOLIA_AGENT_ID = "285a0df9-5996-429f-8f35-7c094337b2e0";
const ALGOLIA_FILTER_TAG_NAME = "filter_attributes.";
const ALGOLIA_REMOVE_FILTER_TAG_NAME01 = "categories.";
const ALGOLIA_REMOVE_FILTER_TAG_NAME02 = "category_path";
const ALGOLIA_REMOVE_FILTER_TAG_NAME03 = "collections";
const ALGOLIA_REMOVE_FILTER_TAG_NAME04 = "wishlist_codes";
const ALGOLIA_REMOVE_FILTER_TAG_NAME05 = "type";
const ALGOLIA_COMMON_FILTERS = [
  "price",
  "vendor",
  "is_partner",
  "availability_color",
];
const ALGOLIA_FOR_STAY_WHOLE_DROPDOWN = [
  "filter_attributes.kompatibilitaet"
]
const ALGOLIA_KEINE_FACET_NAMES = [
  "|Keine Angaben",
  "|Not Specified",
  "|Aucune Indication",
  "|Nessuna Indicazione"
];


const ALGOLIA_REMOVE_KEYS = [
  "categories.",
  "category_path",
  "collections",
  "wishlist_codes",
  "type",
  "box_finder.width",
  "box_finder.length",
  "box_finder.height",
]

const ALGOLIA_MAX_VISIBLE_FACETS = 7;

const ALGOLIA_SORTED_DETAILS = [
  {
    collection: "bestsellers",
    index: "prod_bq_products_best_sellers",
  },
  {
    collection: "just-landed",
    index: "prod_bq_products_descending_published_at",
  },
];

const ALGOLIA_INDEX_NAME_BESTSELLERS = "prod_bq_products_best_sellers";
const ALGOLIA_INDEX_NAME_JUSTLANDED =
  "prod_bq_products_descending_published_at";
const ALGOLIA_INDEX_NAME_COST = "prod_bq_products_cost_asc";

const ALGOLIA_INDEX_NAME_SUGGESTIONS = "prod_bq_products_query_suggestions";
const ALGOLIA_INDEX_NAME_COLLECTIONS = "prod_bq_products_collections";

const CAN_BE_ORDERED_SKUS = ["1165601041", "1400801016"];

const INTERCOM_APP_ID = "jd24cddz";

const SCANDIT_API_KEY =
  "ApBWHr6BKkM4KFihPDu71lAsEK9mKWYeFTD1nNzuTLCUeuaSmlbJc0QE4MSJMFV/HGD2SWpW9Xf7SOrpZT6YG9FkoDKWf2AbZHJZmvBkTqIDUroIT1FwMth9M8iZdNQKMmME5MI3ytcfJT/QRDv0iDI5cr20Ei3krRbtLZRmJnOhtZ3xJFkHBY1zzsaZ5ua9F1DrUw4+FwEIGYMM980J8gbUczGfCSF4kubeS9LWVGkMD/hMfjA0Twd/JbdQsX4VTrPhNgTSRmS1UqiMAQsI11fuFKYB4bApBcNu17T9nQCk2hEm/zxoktbYP9Q/lKDau3oUQ3ATHYSrUarq1ZXQsnfbBak96zwQhXoPwV2Lw5nMI4Gc1oI4sqR1AM8z8j5TtSh9UfZKqL+GoqEaQfhYNc+ThEncqcydujkqvZuEZqJQSAJwoF47IMKkno+NppPsC0B1cDqUryoDlUBiKNykyUq3VBa9/BBioN0V3QoNiHV++1YoSxF/fn4sVK7mbjQJZNtx3OaK2WkV6DLpC9AgkrOdEp8fwu/WuYH+CuWMVIsao/ka0P1HuAGX/INrAq5jiMNEt+0peaoLEloSAgns6HMlu1ehMnrkp/35HdNooHsrlKKuZlK7AoLTLrwEO7Wc6yIe+VW2BisPvTFLR0hBmws7iCL39ktLN1/XZkt2Tjr7NQx1b4u5ZlqpJbwi239rInM9d1cDVGMl7M4BWTQCjTzG4H993w/qVKSUQPR8pqzwh+Xqw6uEveD4/N561Y1N9G147oR6wfUhI0//Y4835CqJRf6XRmYkdHNdtgqje7QzXq5vwNjat3UhAGehKd/w+DuOwQ==";
const IMAGE_PLACEHOLDER =
  "https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png?v=1530129081";
window.SHOP_CONSTANTS = {
  SHOP_ID,
  SHOP_DOMAIN,
  WASSER_TAG,
  CAN_BE_ORDERED_SKUS,
  SPECIFIC_SUPPLIER_TAGS,
  STOREFRONT_ACCESS_TOKEN: STOREFRONT,
  CLIENT_ID,
  REDIRECT_CUSTOMER_URI: REDIRECT,
  VERSION_GRAPH,
  POSTHOG_KEY,
  POSTHOG_HOST,
  POSTHOG_ENV,
  INTERCOM_APP_ID,
  MENU_DATA_BLACKLIST,
  PUNCHOUT_API_KEY,
  PUNCHOUT_ACCOUNTS,
  SHOW_BASE_PRICE_EMAILS,
  SHOW_BASE_PRICE_EXTERNAL_IDS,
  SHOW_NO_PUBLIC_PRODUCTS,
  SECRET_EMAILS,
  TITLE_ABOVE_SUPPLIER_LIST,
  NOTE_SUPPLIER_LIST,
  COST_CENTER_SUPPLIER_LIST,
  API_GRAPH: `https://${SHOP_DOMAIN}/api/${VERSION_GRAPH}/graphql.json`,
  CUSTOMER_API_TOKEN_API: `https://shopify.com/authentication/${SHOP_ID}/oauth/token`,
  CUSTOMER_API_AUTH_API: `https://shopify.com/authentication/${SHOP_ID}/oauth/authorize`,
  CUSTOMER_API_LOGOUT: `https://shopify.com/authentication/${SHOP_ID}/logout`,
  CUSTOMER_API_GRAPH: `https://shopify.com/${SHOP_ID}/account/customer/api/${VERSION_GRAPH}/graphql`,
  API_BACKEND_LITESTAR,
  CARTS_LITESTAR: `${API_BACKEND_LITESTAR}/carts`,
  CREATE_CART_LITESTAR: `${API_BACKEND_LITESTAR}/carts`,
  GET_CARTS_LITESTAR: `${API_BACKEND_LITESTAR}/carts`,
  UPDATE_COMPANY_LOCATION_ROLE_METAFIELD: `${API_BACKEND_LITESTAR}/update_customer_role`,
  ALGOLIA_APP_ID,
  ALGOLIA_API_KEY,
  ALGOLIA_CHAT_API_KEY,
  ALGOLIA_AUTOCOMPLETE_API_KEY,
  ALGOLIA_INDEX_NAME,
  ALGOLIA_AGENT_ID,
  ALGOLIA_INDEX_NAME_SUGGESTIONS,
  ALGOLIA_FILTER_TAG_NAME,
  ALGOLIA_INDEX_NAME_COLLECTIONS,
  ALGOLIA_REMOVE_FILTER_TAG_NAME01,
  ALGOLIA_REMOVE_FILTER_TAG_NAME02,
  ALGOLIA_REMOVE_FILTER_TAG_NAME03,
  ALGOLIA_REMOVE_FILTER_TAG_NAME04,
  ALGOLIA_REMOVE_FILTER_TAG_NAME05,
  ALGOLIA_REMOVE_KEYS,
  ALGOLIA_KEINE_FACET_NAMES,
  ALGOLIA_COMMON_FILTERS,
  ALGOLIA_FOR_STAY_WHOLE_DROPDOWN,
  ALGOLIA_MAX_VISIBLE_FACETS,
  ALGOLIA_INDEX_NAME_BESTSELLERS,
  ALGOLIA_INDEX_NAME_JUSTLANDED,
  ALGOLIA_INDEX_NAME_COST,
  ALGOLIA_SORTED_DETAILS,
  CREATE_WISHLIST_WITH_ITEMS_LITESTAR: `${API_BACKEND_LITESTAR}/wishlists`,
  FAVORITE_PRODUCTS_LITESTAR: `${API_BACKEND_LITESTAR}/favorite_products_contains`,
  ORDERED_BEFORE_PRODUCTS_LITESTAR: `${API_BACKEND_LITESTAR}/ordered_products_contains`,
  WISHLISTS_LITESTIRE: `${API_BACKEND_LITESTAR}/wishlists`,
  WISHLISTS_ARTICLE_LITESTIRE: `${API_BACKEND_LITESTAR}/location_wishlists`,
  WISHLISTS_DETAIL_ARTICLE_LITESTIRE: `${API_BACKEND_LITESTAR}/location_wishlist`,
  WISHLISTS_DETAIL_LAST_BOUGHT_LITESTAR: `${API_BACKEND_LITESTAR}/last_bought`,
  GET_WISHLISTS_LITESTIRE: `${API_BACKEND_LITESTAR}/wishlists`,
  ADD_WISHLIST_ITEM_LITESTAR: `${API_BACKEND_LITESTAR}/wishlists`,
  GET_WISHLIST_DETAIL_LITESTAR: `${API_BACKEND_LITESTAR}/wishlists`,
  DELETE_WISHLIST_LITESTAR: `${API_BACKEND_LITESTAR}/wishlists`,
  UPDATE_WISHLIST_LITESTAR: `${API_BACKEND_LITESTAR}/wishlists`,
  DELETE_WISHLIST_ITEM_LITESTAR: `${API_BACKEND_LITESTAR}/wishlists/items`,
  INVITE_CUSTOMER: `${API_BACKEND_LITESTAR}/invite_customer`,
  DELETE_CUSTOMER: `${API_BACKEND_LITESTAR}/delete_customer`,
  UPDATE_CUSTOMER: `${API_BACKEND_LITESTAR}/update_customer_details`,
  SCANDIT_API_KEY,
  IMAGE_PLACEHOLDER,
  CONTACT_EMAIL,
  CREATE_COMPANY_AND_CONTACT: `${API_BACKEND_LITESTAR}/create_company_and_contact`,
  CONTACT_EMAIL_SHOP,
  RESET_PASSWORD_LITESTAR: `${API_BACKEND_LITESTAR}/send_password_reset`,
  BACKEND_TOKEN_EXCHANGE: `${API_BACKEND_LITESTAR}/auth/exchange`,
  BACKEND_TOKEN_EXCHANGE_ADMIN: `${API_BACKEND_LITESTAR}/exchange_admin`,
  BACKEND_TOKEN_REFRESH: `${API_BACKEND_LITESTAR}/auth/refresh`,
  BACKEND_DEFAULT_INVOICE_EMAIL: `${API_BACKEND_LITESTAR}/update_invoice_emails`,
  INFO_EMAIL_SHOP,
  GET_LOCATION_COST_CENTERS: `${API_BACKEND_LITESTAR}/get_location_cost_centers`,
  ADD_LOCATION_COST_CENTER: `${API_BACKEND_LITESTAR}/add_cost_center`,
  EDIT_LOCATION_COST_CENTER: `${API_BACKEND_LITESTAR}/edit_cost_center`,
  DELETE_LOCATION_COST_CENTER: `${API_BACKEND_LITESTAR}/delete_cost_center`,
  EDIT_COST_CENTER_TYPE: `${API_BACKEND_LITESTAR}/edit_cost_center_type`,
  TRACK_ACCESS_LOCATION: `${API_BACKEND_LITESTAR}/track_access`,
  RECENT_LOCATIONS: `${API_BACKEND_LITESTAR}/recent_locations`,
  CURRENT_CARTS: `${API_BACKEND_LITESTAR}/current_carts`,
  CHECKOUT_CART: `${API_BACKEND_LITESTAR}/checkout`,
  GET_ADMIN_API_WISHLISTS: `${API_BACKEND_LITESTAR}/admin_api/wishlists`,
  GET_ADMIN_API_LOCATION_WISHLISTS: `${API_BACKEND_LITESTAR}/admin_api/location_wishlists`,
  GET_ADMIN_API_LOCATION_INVOICES: `${API_BACKEND_LITESTAR}/admin_api/location_invoices`,
  GET_ADMIN_API_WISHLIST_DETAILS: `${API_BACKEND_LITESTAR}/admin_api/wishlists/`,
  GET_ADMIN_API_LOCATION_WISHLIST_DETAILS: `${API_BACKEND_LITESTAR}/admin_api/location_wishlists/`,
  GET_PRODUCT_PRICE_FOR_LOCATION: `${API_BACKEND_LITESTAR}/admin_api/product_price_for_location`,
  GET_ADMIN_API_CARTS: `${API_BACKEND_LITESTAR}/admin_api/carts`,
  CUSTOMER_LOCATION_ORDERS: `${API_BACKEND_LITESTAR}/customer_location_orders`,
  CUSTOMER_LOCATION_ORDER_DETAILS: `${API_BACKEND_LITESTAR}/customer_order_details`,
  CUSTOMER_ORDER_INVOICES: `${API_BACKEND_LITESTAR}/customer_order_documents`,
  CUSTOMER_LOCATION_INVOICES: `${API_BACKEND_LITESTAR}/customer_location_invoices`,
};